var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"text":_vm.text,"classes":_vm.classes + ' ' + (_vm.toggled ? 'opacity-50 hover:opacity-30' : 'hover:opacity-70')},on:{"buttonClick":function($event){return _vm.$emit('buttonClick')}}})}
var staticRenderFns = []

export { render, staticRenderFns }